import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-productdetailsvari',
  templateUrl: './productdetailsvari.component.html',
  styleUrls: ['./productdetailsvari.component.scss'],
})
export class ProductdetailsvariComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
